import { render, staticRenderFns } from "./ChangePaymentMethod.vue?vue&type=template&id=3de94b4c&scoped=true"
import script from "./ChangePaymentMethod.vue?vue&type=script&lang=js"
export * from "./ChangePaymentMethod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de94b4c",
  null
  
)

export default component.exports